export default __webpack_public_path__ + "static/media/SB-AVAX.d37bb99a.png";